export const VERSION = "1.7.0-beta.0";